import type { Message, NewMessage, Role } from '@/api/types';
import { encryptDeletion, verifyMessage } from '@/crypto';

import { newMessageId } from './outgoing';

/**
 * The deletion mark for a message the owner is about to remove: a message that says which place of which device's run it
 * covers, so a reader does not take the hole for a message the server dropped (docs/FORMAT.md §5). The place is the one
 * the owner's page authenticated by opening the message, not the one the envelope shows, so a server that renumbered the
 * message cannot make the mark cover the wrong number. Null when the message does not open (nothing is known about it).
 */
export async function sealDeletionMark(key: CryptoKey, removed: Message, writer: { readonly bridgeId: string; readonly from: Role }): Promise<NewMessage | null> {
  let place;
  try {
    const envelope = removed.kind === 'text' ? removed.body : removed.header;
    place = (await verifyMessage(key, envelope, { bridgeId: writer.bridgeId, messageId: removed.id, from: removed.from }, removed.kind)).position;
  } catch {
    return null;
  }
  const id = newMessageId();
  return { id, kind: 'text', body: await encryptDeletion(key, place, { ...writer, messageId: id }) };
}
